/**
 * Helper to create new global variable.
 *
 * @param {string} n Name of variable.
 * @param {Object} o Object to put into variable.
 */
export const addWindowVar = (n, o) => {
  window[n] = window[n] || [];
  window[n].push(o);
};

/**
 *  Load dynamically a JS file using Promise.
 *  Example: script('my-id', '//cdn.example.com/file.js') will add script file
 *  <script id="my-id" src="//cdn.example.com/file.js" async></script>
 *  in <head> of page.
 *
 * @param {string} id ID of DOM Element.
 * @param {string} src Script file source.
 * @param {boolean} cached Use file from cache.
 * @returns {Promise}
 */
export default (id, src, cached = true) => (
  new Promise((resolve, reject) => {
    let js = document.createElement('script');

    // If file is already added then resolve Promise
    // and exit from function.
    if (cached && document.getElementById(id)) {
      resolve();
      return true;
    }

    js.id = id;
    js.src = src;
    js.async = true;
    js.onload = resolve;
    js.onerror = reject;

    document.head.appendChild(js)
  })
)
